import { render, staticRenderFns } from "./siteSettingsGeneral.vue?vue&type=template&id=e053092c&"
import script from "./siteSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./siteSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports